// extracted by mini-css-extract-plugin
module.exports = {"metrics_pm":"MemorandumEnviValues_metrics_pm__mez6n","column_metrics":"MemorandumEnviValues_column_metrics__SiJDO"};